var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getNurseAvailableOrgs } from "@iscr/cosmetics/nurseUtils";
import admin_devices_model from "@iscr/models/admin_devices_model";
import firebase_database from "@iscr/xAppLib/providers/firebase_database";
import { useTRPC } from "@iscr/xAppLib/context/QueryProvider";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
/**
 * A component that listens for changes specific to the current user and can respond to specific events like their profile being updated
 */
export const UserPubSub = () => {
    var _a, _b, _c;
    const queryClient = useQueryClient();
    const trpc = useTRPC();
    useEffect(() => firebase_database.watch_changing_records(`user_pub_sub/${app.user.uid}`, (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        console.debug("Received user_pub_sub event:", data);
        switch (data.key) {
            // When the user's profile is updated, we need to check if their org has changed and if so, whether we need to update the device's registered org as well
            case "profile_updated":
                try {
                    const previousDvcFromProfile = !!((_a = app.dvc.dvc_data) === null || _a === void 0 ? void 0 : _a.oid_from_profile);
                    // An unregistered device has the user's own org standing in for one, in memory only
                    // (assignDeviceOrg). Treated as no previous device org.
                    const previousDvcOid = ((_b = app.dvc.dvc_data) === null || _b === void 0 ? void 0 : _b.oid_local_only)
                        ? undefined
                        : (_c = app.dvc.dvc_data) === null || _c === void 0 ? void 0 : _c.oid;
                    const previousUserOid = (_d = app.user.org) === null || _d === void 0 ? void 0 : _d.oid;
                    // Force refresh the ID token to get the latest claims, which may include an updated profile org
                    const idTokenResult = yield app.user.user_obj.getIdTokenResult(true);
                    app.user.refresh(app.user.user_obj, idTokenResult);
                    const [org, profile] = yield Promise.all([
                        app.user.load_org((_e = idTokenResult.claims) === null || _e === void 0 ? void 0 : _e.oid),
                        app.user.load_profile(app.user),
                    ]);
                    app.user.org = org;
                    app.user.set_profile(profile);
                    // The reachable orgs a device may be pointed at are derived from the caller's org as
                    // well as the device's, so this profile reload also invalidates them.
                    void queryClient.invalidateQueries({
                        queryKey: trpc.devices.reachableOrgs.queryKey(),
                    });
                    const { userAvailableOids } = getNurseAvailableOrgs(app.user);
                    if (app.acl.is_nurse &&
                        previousUserOid !== ((_f = app.user.org) === null || _f === void 0 ? void 0 : _f.oid) &&
                        // We only update the device ID if the current device org is from the profile,
                        // otherwise we'll override a manually configured device org and remove the nurse's access to that org
                        previousDvcFromProfile &&
                        previousDvcOid &&
                        // If the new profile org still has access to the current device org, we can leave it as is.
                        // The user's orgs alone, not availableOrgMap: that unions in the device org's own subtree,
                        // which always contains the device org, so the check could never fail.
                        !userAvailableOids.has(previousDvcOid)) {
                        yield admin_devices_model.set_dvc_oid({
                            oid: (_h = (_g = app.user.org) === null || _g === void 0 ? void 0 : _g.oid) !== null && _h !== void 0 ? _h : null,
                        });
                    }
                }
                catch (error) {
                    console.error("Error handling user_pub_sub event:", error);
                }
                break;
            default:
                console.warn(`Unhandled user_pub_sub event: ${JSON.stringify(data)}`);
        }
    })), [
        (_a = app.user.org) === null || _a === void 0 ? void 0 : _a.oid,
        (_b = app.dvc.dvc_data) === null || _b === void 0 ? void 0 : _b.oid,
        // @ts-expect-error type error due to | false
        (_c = app.dvc.org) === null || _c === void 0 ? void 0 : _c.oid,
        queryClient,
        trpc,
    ]);
    return null;
};
